const THREE = require('three')
import Doors from '@/components/Stage/intro/doors'
  
class Cave extends THREE.Group {

  constructor(config) {

    super();
   
    this.renderer = config.renderer;
    this.position.y = -690;
    this.position.z = -200;

    this.setup(); 
    this.resize() 
  } 

  setup() { 
 
    this.cave_plane_top = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(window.innerWidth, 80), 
      new THREE.MeshBasicMaterial({ color: 0xfdff33 })
    );  
    this.cave_plane_top.position.y = -290;
    this.cave_plane_top.position.x = -100;
    this.cave_plane_top.position.z = -30;

    this.cave_plane_left = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1000, 400), 
      new THREE.MeshBasicMaterial({ color: 0xfdff33 })
    );  
    this.cave_plane_left.position.y = -510;
    this.cave_plane_left.position.x = -550;
    this.cave_plane_left.position.z = -30;

    this.cave_plane_right = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1000, 400), 
      new THREE.MeshBasicMaterial({ color: 0xfdff33 })
    );  
    this.cave_plane_right.position.y = -510;
    this.cave_plane_right.position.x = 550;
    this.cave_plane_right.position.z = -30;

 

    this.cave_plane_bottom = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(window.innerWidth, 100), 
      new THREE.MeshBasicMaterial({ color: 0xfdff33 })
    );  
    this.cave_plane_bottom.position.y = -500;
    this.cave_plane_bottom.position.x = -100;
    this.cave_plane_bottom.position.z = -25;


    this.cave_wall_one = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 * 0.15, 1024 * 0.15), 
      new THREE.MeshBasicMaterial({ 
        map: this.createTexture(require('@/assets/img/cave/wall-1.png')),
        transparent: true
      })
    );  
    this.cave_wall_one.position.y = -400;
    this.cave_wall_one.position.x = 20;
    this.cave_wall_one.position.z = -25; 

    this.cave_wall_two = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 * 0.15, 1024 * 0.15), 
      new THREE.MeshBasicMaterial({ 
        map: this.createTexture(require('@/assets/img/cave/wall-2.png')),
        transparent: true
      })
    );  
    this.cave_wall_two.position.y = -400;
    this.cave_wall_two.position.x = 10;
    this.cave_wall_two.position.z = -30; 


    this.cave_wall_three = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 * 0.2, 1024 * 0.2), 
      new THREE.MeshBasicMaterial({ 
        map: this.createTexture(require('@/assets/img/cave/wall-3.png')),
        transparent: true
      })
    );  
    this.cave_wall_three.position.y = -410;
    this.cave_wall_three.position.x = -10;
    this.cave_wall_three.position.z = -100; 

    this.cave_wall_four = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 * 0.11, 512 * 0.11), 
      new THREE.MeshBasicMaterial({ 
        map: this.createTexture(require('@/assets/img/cave/wall-4.png')),
        transparent: true
      })
    );  
    this.cave_wall_four.position.y = -350;
    this.cave_wall_four.position.x = -10;
    this.cave_wall_four.position.z = -60; 

    this.cave_wall_five = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 * 0.15, 512 * 0.15), 
      new THREE.MeshBasicMaterial({ 
        map: this.createTexture(require('@/assets/img/cave/wall-5.png')),
        transparent: true
      })
    );  
    this.cave_wall_five.position.y = -350;
    this.cave_wall_five.position.x = 0;
    this.cave_wall_five.position.z = -100; 

    this.cave_wall_six = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(512 * 0.32, 512 * 0.32), 
      new THREE.MeshBasicMaterial({ 
        map: this.createTexture(require('@/assets/img/cave/wall-6.png')),
        transparent: true
      })
    );  
    this.cave_wall_six.position.y = -370;
    this.cave_wall_six.position.x = 30;
    this.cave_wall_six.position.z = -150; 

    this.cave_wall_seven= new THREE.Mesh(
      new THREE.PlaneBufferGeometry(512 * 0.5, 512 * 0.5), 
      new THREE.MeshBasicMaterial({ 
        map:this.createTexture(require('@/assets/img/cave/wall-7.png')),
        transparent: true
      })
    );  
    this.cave_wall_seven.position.y = -410;
    this.cave_wall_seven.position.x = 10;
    this.cave_wall_seven.position.z = -200; 

    this.rocks  = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(512 * 0.2, 512 * 0.2), 
      new THREE.MeshBasicMaterial({ 
        map: this.createTexture(require('@/assets/img/cave/wall-8.png')),
        transparent: true
      })
    );  
    this.rocks.position.y = -460;
    this.rocks.position.x = 35;
    this.rocks.position.z = -180; 

      //  this.cave_plane_bg = new THREE.Mesh(
      //   new THREE.PlaneBufferGeometry(200, 200), 
      //   new THREE.MeshBasicMaterial({ color: 0x2e385c })
      // );  
      // this.cave_plane_bg.position.y = -450;
      // this.cave_plane_bg.position.x = 20;
      // this.cave_plane_bg.position.z = -420;

    this.add(this.cave_plane_top);
    this.add(this.cave_plane_bottom);
    this.add(this.cave_plane_left);
    this.add(this.cave_plane_right);

    this.add(this.cave_wall_one); 
    this.add(this.cave_wall_two); 
    this.add(this.cave_wall_three); 
    this.add(this.cave_wall_four);
    this.add(this.cave_wall_five);
    this.add(this.cave_wall_six);
    this.add(this.cave_wall_seven);
    this.add(this.rocks); 
 
    this.doors = new Doors({
      renderer: this.renderer
    });
    this.add(this.doors)

  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img);   
    texture.needsUpdate = true;
    return texture;
  }

  updateRoute(val) { 
    this.doors.updateRoute(val) 
  }

  resize() {  }

  tick(scroll_ratio){
    
    if(scroll_ratio > 0.57){

      this.doors.visible = true;
      this.doors.tick(scroll_ratio);

    } else{
      this.doors.visible = false;
    }
  } 
 
 
}

export default Cave